import { createStore } from "jotai";
import { atom } from "jotai";
import { PaymentOption } from "./PaymentOptionRadioGroup";

export const jotaiStore = createStore();

export const bookingGuidAtom = atom<string | null>(null);
export const ownerGuidAtom = atom<string | null>(null);
export const isAuthenticatedAtom = atom<boolean>(false);
export const paymentOptionAtom = atom(PaymentOption.Full);
